module.exports = __webpack_public_path__ + "img/cyberviz-1.9370260f.png";